import "./boot";
import "./mimeticss";

import Common from "./app/Common";
import Reviews from "./app/Reviews";
import Paginations from "./app/Paginations";
import Albums from "./app/Albums";
import Sharing from "./app/Sharing";
import Announcements from "./app/Announcements";
import MembersArea from "./app/MembersArea";
import Newsletter from "./app/Newsletter";
import Ads from "./app/Ads";
import Portfolio from "./app/Portfolio";

const common = new Common();
const reviews = new Reviews();
const paginations = new Paginations();
const albums = new Albums();
const sharing = new Sharing();
const announcements = new Announcements();
const membersArea = new MembersArea();
const newsletter = new Newsletter();
const portfolio = new Portfolio();

common.init();
reviews.init();
paginations.init();
albums.init();
sharing.init();
announcements.init();
membersArea.init();
newsletter.init();
portfolio.init();

// New programming style, we're using functional from now on
// Or not :D
Ads();
